module.exports = __webpack_public_path__ + "static/media/no_trading_data.dd4474a9.svg";